import { Component, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { CentreService } from '../../../../services/centre.service';
import { Subject } from 'rxjs';
import { Centre } from '../../../../interfaces/Centres';
import { FullChild } from '../../../../interfaces/FullChild';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import * as XLSX from "xlsx";
import {PermissionType} from "../../../../components/employee/PermissionType.enum";

@Component({
  selector: 'app-hospital-wise-occupancy',
  templateUrl: './hospital-wise-occupancy.component.html',
  styleUrls: ['./hospital-wise-occupancy.component.scss']
})
export class HospitalWiseOccupancyComponent implements OnInit, OnDestroy {
  private _destroyed$ = new Subject();
  mCentres: Centre[] = [];
  allCentres: any[] = [];
  totalUnits = 0;
  totalOccupiedUnits = 0;
  totalAvailableUnits = 0;
  centrePercentage = 0;
  totalRanking = 0;
  availableOccupied: any;
  HospitalName: any[] = [];
  isLoading = false;
  todayDate: Date;
  fileName = 'Hospital Wise Occupancy Reports.xlsx';



  constructor(
    private centreService: CentreService,
    private mFirestore: AngularFirestore
  ) {
    this.todayDate = new Date();
  }

  ngOnInit(): void {
    this.initAllCentresData('All');
    this.initAlChild();
  }
  isMaharashtraCenter(centreName: string): boolean {
    const maharashtraCenters = ['AL Pune', 'AL Sandu Garden', 'AL Diamond Garden', 'AL Gurunanak Niwas','AL Borivali'];
    return maharashtraCenters.includes(centreName);
  }
  printDoc() {
    let PrintHospitalOccupancy;
    const previewElement = document.getElementById('preview');
    if (previewElement) {
      PrintHospitalOccupancy = previewElement.innerHTML;
    } else {
      console.error('Element with ID "preview" not found.');
      return;
    }

    const popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
      <html>
        <head>
          <title>Hospital Wise Occupancy</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 10px;
            }

            /* Styles for the card */
            .card {
              background-color: #f9f9f9;
              border-radius: 8px;
              padding: 10px;
            }

            /* Main heading style */
            h1 {
              font-size: 25px;
              color: #333;
            }

            /* Section header style */
            .section-header {
              background-color: #f4b400;
              color: black;
              padding: 10px;
              border-radius: 4px;
              margin-top: 10px;
              text-align: left;
            }

            /* Center title style */
            .center-title {
              font-size: 20px;
              color: #333;
              margin-top: 10px;
              text-align: center;
            }

            /* Table styles */
            .custom-table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 15px;
            }
            .custom-table th {
              background-color: white;
              color: #000;
              padding: 12px;
              border: 1px solid #000;
              text-align: center;
            }
            .custom-table td {
              padding: 10px;
              border: 1px solid #000;
              text-align: center;
              color: #000;
            }

            /* Highlight row for totals */
            .custom-table .table-warning {
              background-color: #fff3cd;
              font-weight: bold;
            }

            /* Remove hover effect for print */
            .custom-table tbody tr:hover {
              background-color: transparent;
            }

            /* Enforce colors for print */
            @media print {
              .section-header {
                background-color: #f4b400 !important;
                color: black !important;
              }
              .custom-table th {
                background-color: white !important;
                color: #000 !important;
              }
              .custom-table .table-warning {
                background-color: #fff3cd !important;
                color: #000 !important;
              }
            }
          </style>
        </head>
        <body onload="window.print(); window.close();">
          ${PrintHospitalOccupancy}
        </body>
      </html>
    `);
      popupWin.document.close();
    } else {
      console.error('Popup window could not be opened.');
    }
  }




  calculateAverage() {
    const totals = this.allCentres.reduce((acc, center) => {
      if (this.isMaharashtraCenter(center.centreName)) {
        acc.totalCapacity += center.totalUnits;
        acc.totalOccupied += center.occupiedUnits;
        acc.totalCount += 1;
      }
      return acc;
    }, { totalCapacity: 0, totalOccupied: 0, totalCount: 0 });

    const averagePercentage = totals.totalCount ? (totals.totalOccupied / totals.totalCapacity) * 100 : 0;

    return {
      totalOccupied: totals.totalOccupied,
      totalCapacity: totals.totalCapacity,
      averageOccupied: totals.totalCount ? Math.round(totals.totalOccupied / totals.totalCount) : 0,
      averagePercentage: Math.round(averagePercentage),
    };
  }

  calculateOutstationAverage() {
    const totals = this.allCentres.reduce((acc, center) => {
      if (!this.isMaharashtraCenter(center.centreName)) {
        acc.totalCapacity += center.totalUnits;
        acc.totalOccupied += center.occupiedUnits;
        acc.totalCount += 1;
      }
      return acc;
    }, { totalCapacity: 0, totalOccupied: 0, totalCount: 0 });

    const averagePercentage = totals.totalCount ? (totals.totalOccupied / totals.totalCapacity) * 100 : 0;

    return {
      totalOccupied: totals.totalOccupied,
      totalCapacity: totals.totalCapacity,
      averageOccupied: totals.totalCount ? Math.round(totals.totalOccupied / totals.totalCount) : 0,
      averagePercentage: Math.round(averagePercentage),
    };
  }



  private initAllCentresData(centreCode: string): void {
    if (centreCode === 'All') {
      this.isLoading = true;
      this.centreService.getAllCentres().pipe(takeUntil(this._destroyed$)).subscribe(centres => {
        this.allCentres = centres.filter(c => c.centreCode !== 'ALBandra');
        this.calculateCentreTotals();
        // Sort centers by centreName in ascending order (A to Z)
        this.allCentres.sort((a, b) => a.centreName.localeCompare(b.centreName));
        this.isLoading = false;
      });
    } else {
      this.mCentres = this.allCentres.filter(c => c.centreCode === centreCode);
      this.calculateCentreTotals();
      this.isLoading = false;
    }
  }

  private calculateCentreTotals(): void {
    this.totalUnits = 0;
    this.totalAvailableUnits = 0;
    this.totalOccupiedUnits = 0;
    this.centrePercentage = 0;
    this.totalRanking = 0;

    this.allCentres.forEach(c => {
      this.totalUnits += +c.totalUnits!;
      this.totalAvailableUnits += +c.availableUnits!;
      this.totalOccupiedUnits += +c.occupiedUnits!;
      c.centrePercentage = parseFloat(this.getPercentage(c));
      c.totalRanking = parseFloat(c.totalRanking.toFixed(0));
    });
  }

  getPercentage(element: Centre): string {
    if (element.totalUnits && element.occupiedUnits) {
      const percentage = ((+element.occupiedUnits / +element.totalUnits) * 100).toFixed(2);
      this.availableOccupied = element.occupiedUnits;
      return percentage;
    }
    return 'error';
  }



  initAlChild(): void {
    this.isLoading = true;
    this.mFirestore
      .collection<FullChild>('ALChild', ref => ref.orderBy('centreName'))
      .valueChanges({ idField: 'id' })
      .pipe(takeUntil(this._destroyed$))
      .subscribe(res => {
        const filteredAllotedChildren = res.filter(child => child.isAlloted);
        const centerWiseHospitals: {
          [key: string]: { hospitals: string[]; hospitalCount: { [key: string]: number } };
        } = {};

        filteredAllotedChildren.forEach(child => {
          const center = child.centreName;
          const hospital = child.hospital || 'Unknown';

          if (!centerWiseHospitals[center]) {
            centerWiseHospitals[center] = { hospitals: [], hospitalCount: {} };
          }

          if (!centerWiseHospitals[center].hospitals.includes(hospital)) {
            centerWiseHospitals[center].hospitals.push(hospital);
          }

          if (!centerWiseHospitals[center].hospitalCount[hospital]) {
            centerWiseHospitals[center].hospitalCount[hospital] = 0;
          }

          centerWiseHospitals[center].hospitalCount[hospital]++;
        });

        this.HospitalName = Object.keys(centerWiseHospitals).map(center => ({
          centreName: center,
          hospitals: centerWiseHospitals[center].hospitals,
          hospitalCount: centerWiseHospitals[center].hospitalCount
        }));

        this.isLoading = false;
      });
  }

  exportexcel() {
    const exportData: Array<{ [key: string]: any }> = []; // Define the type for exportData

    // Helper function to create a row for each center, including hospital information
    const createRow = (center: Centre, region: string): { [key: string]: any } => {
      const row: { [key: string]: any } = {
        "Region": region,
        "Center Name": center.centreName,
        "Capacity": center.totalUnits,
        "Occupied": center.occupiedUnits,
        "Percentage": this.getPercentage(center) + '%' // Percentage with '%'
      };

      // Add each hospital's occupancy count in the current center
      this.HospitalName.forEach((hospitalData: any) => {
        if (hospitalData.centreName === center.centreName) {
          hospitalData.hospitals.forEach((hospital: string) => {
            row[hospital] = hospitalData.hospitalCount[hospital] || 0; // Default to 0 if undefined
          });
        }
      });

      return row;
    };

    // Gather data for Outstation centers
    this.allCentres.forEach(center => {
      if (!this.isMaharashtraCenter(center.centreName)) {
        exportData.push(createRow(center, 'OUTSTATION'));
      }
    });

    // Gather data for Maharashtra centers
    this.allCentres.forEach(center => {
      if (this.isMaharashtraCenter(center.centreName)) {
        exportData.push(createRow(center, 'MAHARASHTRA'));
      }
    });

    // Convert data to a worksheet
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(exportData);

    // Create a workbook and append the worksheet
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Occupancy Reports');

    // Save the file as an Excel document
    XLSX.writeFile(wb, 'Occupancy_Report.xlsx');
  }





  ngOnDestroy(): void {
    this._destroyed$.complete();
  }

  protected readonly PermissionType = PermissionType;
}
